import { TypeOptions, toast } from 'react-toastify';

const CONFIG = {
  hideProgressBar: true,
  autoClose: 3000,
  closeOnClick: false,
  closeButton: false,
  style: {
    borderRadius: '3px',
    background: 'rgba(0, 0, 0, 0.7)',
    color: '#fff',
    height: '40px',
  },
};

export const styledToast = (message: string, type?: TypeOptions) => {
  const t = type ? toast[type] : toast;

  t(message, CONFIG);
};
